import { SHORT_AVAILABILITY_MESSAGING } from './availabilityMessages.js'

const DELIVERY_1_MAN_FROM_TOMORROW = 'DELIVERY_1_MAN_FROM_TOMORROW'

const FULFILMENT_TYPES = {
  COLLECTION: 'collection',
  DELIVERY: 'delivery'
}

function getFulfilmentOption(messageKey, icon, isDisabled) {
  if (isDisabled) {
    return {
      message: SHORT_AVAILABILITY_MESSAGING.UNAVAILABLE,
      availabilityIcon: 'out_of_stock'
    }
  }

  return {
    message: SHORT_AVAILABILITY_MESSAGING[messageKey] || null,
    availabilityIcon: icon
  }
}

function getAvailabilityMessage(message, location, messageKey) {
  if (typeof message !== 'string') return message

  // Handle specifically for DELIVERY_1_MAN_FROM_TOMORROW key, as "to {0}" is in middle of message (instead of the end)
  // Previous message: Order now for delivery to {0} tomorrow
  if (messageKey === DELIVERY_1_MAN_FROM_TOMORROW) {
    return 'Order now for delivery tomorrow to:'
  }

  const trimmedMessage = message.trim()
  return trimmedMessage.endsWith(location) ? `${trimmedMessage.replace(location, '').trim()}:` : message
}

export { FULFILMENT_TYPES, getAvailabilityMessage, getFulfilmentOption }
